// =====================================================
// INSURANCE COMPANIES API
// Actualizado: incluye policiesCount
// =====================================================

import { api } from './client';

export interface InsuranceCompany {
  id: string;
  companyId: string;
  code: string;
  name: string;
  phone: string | null;
  email: string | null;
  isActive: boolean;
  policiesCount?: number;
  createdAt: string;
  updatedAt: string;
}

export interface InsuranceCompanySelect {
  id: string;
  code: string;
  name: string;
}

export const insuranceCompaniesApi = {
  /**
   * Obtener lista para select (solo activas)
   */
  getForSelect: (): Promise<InsuranceCompanySelect[]> => {
    return api.get<InsuranceCompanySelect[]>('/insurance-companies/select');
  },

  /**
   * Obtener todas las compañías
   */
  getAll: (includeInactive = false): Promise<InsuranceCompany[]> => {
    const query = includeInactive ? '?includeInactive=true' : '';
    return api.get<InsuranceCompany[]>(`/insurance-companies${query}`);
  },

  /**
   * Obtener una compañía por ID
   */
  getById: (id: string): Promise<InsuranceCompany> => {
    return api.get<InsuranceCompany>(`/insurance-companies/${id}`);
  },

  /**
   * Crear nueva compañía (solo admin)
   */
  create: (data: { code: string; name: string; phone?: string; email?: string }): Promise<InsuranceCompany> => {
    return api.post<InsuranceCompany>('/insurance-companies', data);
  },

  /**
   * Actualizar compañía (solo admin)
   */
  update: (id: string, data: Partial<{ code: string; name: string; phone: string; email: string; isActive: boolean }>): Promise<InsuranceCompany> => {
    return api.patch<InsuranceCompany>(`/insurance-companies/${id}`, data);
  },

  /**
   * Desactivar compañía (solo admin)
   */
  deactivate: (id: string): Promise<InsuranceCompany> => {
    return api.delete<InsuranceCompany>(`/insurance-companies/${id}`);
  },

  /**
   * Reactivar compañía (solo admin)
   */
  reactivate: (id: string): Promise<InsuranceCompany> => {
    return api.patch<InsuranceCompany>(`/insurance-companies/${id}/reactivate`);
  },
};

export default insuranceCompaniesApi;
